import { render, staticRenderFns } from "./standard-form.vue?vue&type=template&id=4441a83c&scoped=true&"
import script from "./standard-form.vue?vue&type=script&lang=ts&"
export * from "./standard-form.vue?vue&type=script&lang=ts&"
import style0 from "./standard-form.vue?vue&type=style&index=0&id=4441a83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4441a83c",
  null
  
)

export default component.exports